export default function Img({value}) {
  return <img src={value} alt="" />;
}
